/*
There are many controls that will have their own custom way of displaying their summary.

This is a singleton class that requires no instanciation that can be used to create methods for the custom summaries
that can then be passed to the clientControl as a custom call back option (customGetSummaryCallback).

Use like this..

var clientControlTest = $("#clientControlTest").clientControl({
    customGetSummaryCallback: clientControlSummaries.commaSeparatedUnderParent,
    summaryObjectId: 'clientControlSummary',
    summaryObjectEmptyMessage: 'None Selected',
    webServiceUrl: '/WebServices/Lookups.asmx/GetCountryState'
});

*/
var clientControlSummaries = {
    commaSeperatedWithRemove: function (clientControl) {
        var summary = null;

        var selected = clientControl.jsonManager.getSelectedItems();

        if (selected && selected.length > 0) {

            summary = $('<span>');
            summary.append('Selected:<br />');

            for (var i = 0; i < selected.length; i++) {
                var txt = $('<span>');

                var unSelectItem = $("<span>");
                unSelectItem.click({ 'jsonItem': selected[i] }, function (event) {
                    clientControl.unselect(event.data.jsonItem);
                });

                var img = $("<img>", { src: '/Resources/images/remove.png' });
                img.mouseover(function () {
                    $(this).attr('src', '/Resources/images/removeHover.png');
                });
                img.mouseout(function () {
                    $(this).attr('src', '/Resources/images/remove.png');
                });

                unSelectItem.append(img);
                summary.append(selected[i].Name);
                summary.append(unSelectItem);
                if (i + 1 < selected.length) {
                    summary.append(', ');
                }
            }

        }

        return summary;
    },



    commaSeperatedNoTitle: function (clientControl) {
        var summary = null;

        var selected = clientControl.jsonManager.getSelectedItems();

        if (selected && selected.length > 0) {
            var selectedNames = new Array();

            for (var i = 0; i < selected.length; i++) {
                selectedNames.push(selected[i].Name);
            }

            summary = selectedNames.join(', ');
        }

        return summary;
    },



    commaSeperated: function (clientControl) {
        var summary = clientControlSummaries.commaSeperatedNoTitle(clientControl);

        if (summary) {
            summary = 'Selected:<br />' + summary;
        }

        return summary;
    },



    /*
    Gives a summary like this...

    Instructional Faculty
    • 	Business Education - Accounting/Finance, Business Administration
    • 	Career and Technical Education - All
    Support Staff & Services
    • 	Academic Affairs - All
    • 	Instructional Support - In-School Suspension
    */
    titlesAndBullets: function (clientControl) {
        var html = '';
        var selected = clientControl.jsonManager.getSelectedIDs();

        for (var top = 0; top < clientControl.jsonManager.json.length; top++) {

            var parentSummary = '';

            if (clientControl.jsonManager.json[top].Children) {
                var childrenSummary = '';
                for (var parent = 0; parent < clientControl.jsonManager.json[top].Children.length; parent++) {
                    if (clientControl.jsonManager.json[top].Children[parent].Children) {
                        var allSelected = clientControl.jsonManager.json[top].Children[parent].Children.length > 0; // If there aren't any children, then they can't all be selected
                        var childrenList = new Array();
                        for (var child = 0; child < clientControl.jsonManager.json[top].Children[parent].Children.length; child++) {
                            var currentID = clientControl.jsonManager.json[top].Children[parent].Children[child].ID;
                            if (jQuery.inArray(currentID, selected) > -1) {
                                childrenList.push(clientControl.jsonManager.json[top].Children[parent].Children[child].Name);
                            }
                            else {
                                allSelected = false;
                            }
                        }

                        if (allSelected) {
                            childrenSummary = 'all';
                        }
                        else {
                            if (childrenList.length > 0) {
                                childrenSummary = childrenList.join(", ");
                            }
                            else {
                                childrenSummary = '';
                            }
                        }
                    }

                    if (childrenSummary != '') {
                        parentSummary += "<table cellpadding='0' cellspacing='0' border='0'><tr><td width='10'>&nbsp;</td><td valign='top'>•&nbsp;</td><td>" + clientControl.jsonManager.json[top].Children[parent].Name + " - " + childrenSummary + "</td></tr></table>";
                    }
                    else {
                        // Could be a single parent with no children selected
                        if (jQuery.inArray(clientControl.jsonManager.json[top].Children[parent].ID, selected) > -1) {
                            parentSummary += "<table cellpadding='0' cellspacing='0' border='0'><tr><td width='10'>&nbsp;</td><td valign='top'>•&nbsp;</td><td>" + clientControl.jsonManager.json[top].Children[parent].Name + "</td></tr></table>";
                        }
                    }
                }
            }

            if (parentSummary != '') {
                html += "<span class='mtext'><u>" + clientControl.jsonManager.json[top].Name + "</u><br>" + parentSummary + "</span>";
            }
        }
        return html;
    },

    titlesAndBullets2: function (clientControl) {
        var html = '';

        var list = clientControl.jsonManager.getList();

        if (list) {
            for (var top = 0; top < list.length; top++) {

                if (list[top].Selected || clientControl.jsonManager.someChildrenSelected(list[top])) {

                    html += '<u>' + list[top].Name + '</u><br />';

                    if (list[top].Children && list[top].Children.length > 0) {

                        html += '<table cellpadding="0" cellspacing="0" border="0"><tbody>';

                        for (var parent = 0; parent < list[top].Children.length; parent++) {

                            if (list[top].Children[parent].Selected || clientControl.jsonManager.someChildrenSelected(list[top].Children[parent])) {

                                html += '<tr><td width="10">&nbsp;</td><td valign="top">•&nbsp;</td><td>' + list[top].Children[parent].Name;

                                if (list[top].Children[parent].Children && list[top].Children[parent].Children.length > 0) {

                                    html += ' - ';
                                    if (clientControl.jsonManager.allChildrenSelected(list[top].Children[parent])) {
                                        html += 'All';
                                    }
                                    else {
                                        var thirdSelected = clientControl.jsonManager.getSelectedItems(list[top].Children[parent].Children);
                                        var selectedNames = new Array();

                                        for (var third = 0; third < thirdSelected.length; third++) {
                                            selectedNames.push(thirdSelected[third].Name);
                                        }

                                        html += selectedNames.join(', ');
                                    }
                                }

                                html += '</td></tr>';
                            }
                        }

                        html += '</tbody></table>';
                    }
                }

            }
        }
        return html;
    },


    /*
    Gives a summary like this...

    Selected:
    United States - Alaska, Arizona, Delaware
    Canada - All
    Andorra, Australia, Austria, Bosnia and Hersegovina, Burundi
    */
    commaSeparatedUnderParent: function (clientControl) {
        var summary = '';

        var list = clientControl.jsonManager.getList();

        var lastAddedParentSummary = false;
        var lastAddedSingle = false;

        for (var i = 0; i < list.length; i++) {

            var hasChildrenSelected = clientControl.jsonManager.someChildrenSelected(list[i]);

            if (list[i].Selected || hasChildrenSelected) {

                if (hasChildrenSelected) {
                    if (summary) summary += '<br />';

                    var summaryLine = list[i].Name + ' - ';

                    if (clientControl.jsonManager.allChildrenSelected(list[i])) {
                        summaryLine += 'All';
                    }
                    else {
                        var selectedNames = new Array();

                        var selectedItems = clientControl.jsonManager.getSelectedItems(list[i].Children);

                        for (var j = 0; j < selectedItems.length; j++) {
                            selectedNames.push(selectedItems[j].Name);
                        }

                        summaryLine += selectedNames.join(', ');
                    }

                    summary += summaryLine;

                    lastAddedParentSummary = true;
                    lastAddedSingle = false;
                }
                else {
                    if (lastAddedParentSummary) {
                        if (summary) summary += '<br />';
                    }
                    if (lastAddedSingle) {
                        if (summary) summary += ', ';
                    }
                    summary += list[i].Name;

                    lastAddedParentSummary = false;
                    lastAddedSingle = true;
                }
            }
        }

        /*
        if (summary) {
            summary = 'Selected:<br />' + summary;
        }
        */

        return summary;
    }, 

    geographicLocations: function (clientControl) {
        var html = '';
        var selected = clientControl.jsonManager.getSelectedIDs();

        for (var top = 0; top < clientControl.jsonManager.json.length; top++) {

            var parentSummary = '';

            if (clientControl.jsonManager.json[top].Children) {
                var childrenSummary = '';
                for (var parent = 0; parent < clientControl.jsonManager.json[top].Children.length; parent++) {
                    if (clientControl.jsonManager.json[top].Children[parent].Children) {
                        var allSelected = clientControl.jsonManager.json[top].Children[parent].Children.length > 0; // If there aren't any children, then they can't all be selected
                        var childrenList = new Array();
                        for (var child = 0; child < clientControl.jsonManager.json[top].Children[parent].Children.length; child++) {
                            var currentID = clientControl.jsonManager.json[top].Children[parent].Children[child].ID;
                            if (jQuery.inArray(currentID, selected) > -1) {
                                childrenList.push(clientControl.jsonManager.json[top].Children[parent].Children[child].Name);
                            }
                            else {
                                allSelected = false;
                            }
                        }

                        if (allSelected) {
                            childrenSummary = 'all';
                        }
                        else {
                            if (childrenList.length > 0) {
                                childrenSummary = childrenList.join(", ");
                            }
                            else {
                                childrenSummary = '';
                            }
                        }
                    }

                    if (childrenSummary != '') {
                        parentSummary += "<table cellpadding='0' cellspacing='0' border='0'><tr><td>" + clientControl.jsonManager.json[top].Children[parent].Name + " - " + childrenSummary + "</td></tr></table>";
                    }
                    else {
                        // Could be a single parent with no children selected
                        if (jQuery.inArray(clientControl.jsonManager.json[top].Children[parent].ID, selected) > -1) {
                            parentSummary += "<table cellpadding='0' cellspacing='0' border='0'><tr><td>" + clientControl.jsonManager.json[top].Children[parent].Name + "</td></tr></table>";
                        }
                    }
                }
            }

            if (parentSummary != '') {
                html += parentSummary + "</span>";
            }
        }
        return html;
    }

};


